/*
 * @Author: zhouwei
 * @Date: 2019-11-18 15:32:37
 * @Last Modified by: zhouwei
 * @Last Modified time: 2019-12-17 19:43:05
 * @Desc: 底部操作条
*/
<template>
  <div
    v-if="show"
    class="handle-data"
  >
    <div
      v-if="checkAll"
      class="shade"
    ></div>
    <div class="select">
      <div class="select-data">
        <mk-checkbox
          v-model="checkAll"
          @change="change"
        ></mk-checkbox>
        <span class="txt">选择查询条件下所有客户（单次批量操作最多选中1000条）</span>
      </div>
      <div class="select-num">
        <div
          class="export"
          @click="exportFormData"
        >
          <mk-iconfont
            class="icon"
            icon-class="daochu"
          ></mk-iconfont>
          <span class="txt">导出</span>
        </div>
        <div class="txt">
          共选择<span>{{ showNum }}</span>项
        </div>
        <mk-button-biz
          type="text"
          @click="cancel"
        >
          取消
        </mk-button-biz>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      defalut: true
    },
    selectNumber: {
      type: Number,
      default: 0
    },
    exportUrl: {
      type: String,
      default: ''
    },
    screen: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      checkAll: false,
      title: ''
    }
  },
  computed: {
    showNum () {
      if (this.checkAll) {
        if (this.screen > 1000) {
          return 1000
        } else {
          return this.screen
        }
      } else {
        return this.selectNumber
      }
    }
  },
  created () {
    this.title = this.$route.query.title
  },
  methods: {
    cancel () {
      // 取消选择
      this.checkAll = false
      this.$emit('cancel')
    },
    exportFormData () {
      // 导出表单数据
      this.$emit('export-data', this.checkAll)
    },
    change (e) {
      this.$emit('check-all', e)
    }
  }
}
</script>
<style lang="scss" scoped>
.handle-data {
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  width: 100%;
  height: 64px;
  // padding: 0 20px 0 36px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #ccc;
  position: relative;
  // bottom: 0;
  // left: 0;
  z-index: 99;

  .shade {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.32);
  }

  .select {
    position: relative;
    z-index: 100;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px 0 36px;

    .select-data {
      .txt {
        font-size: 14px;
        margin-left: 8px;
      }
    }

    .select-num {
      display: flex;
      height: 100%;
      align-items: center;

      .txt {
        font-size: 14px;
        margin-right: 8px;

        span {
          color: #009cf0;
          margin: 0 4px;
        }
      }

      .export {
        cursor: pointer;
        margin-right: 30px;

        .icon {
          color: #595959;
        }

        .txt {
          font-size: 14px;
          color: #595959;
          margin-left: 4px;
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
